import Mobile from './mobile'
import Pc from './pc'

const Footer = ({ isMobileDevice = false }) => (isMobileDevice ? <Mobile /> : <Pc />)

export default Footer
